// src/hooks/useCarModelQuery.ts
import { useQuery } from '@tanstack/react-query';
import { CarModelService, CarModel } from '../Services/carModelService';

export const CAR_MODEL_QUERY_KEYS = {
  byBrand: (brandId: string) => ['publicCarModels', 'byBrand', brandId] as const,
};

// Only fetches once a real brandId is selected — there is no "all models
// across all brands" listing needed on the client.
export const useCarModelsByBrand = (brandId: string | undefined) => {
  return useQuery<CarModel[]>({
    queryKey: CAR_MODEL_QUERY_KEYS.byBrand(brandId || ''),
    queryFn: () => CarModelService.getActiveModelsByBrand(brandId!),
    enabled: !!brandId && brandId !== '*',
    staleTime: 1000 * 60 * 10,
  });
};
